/* =========================================================================
   Voog — Tracking helpers (Pre-launch site)
   Add to theme.liquid, once, right after vg-signup.js, before </body>:
     {{ 'vg-tracking.js' | asset_url | script_tag }}

   Requires the Meta Pixel base code + GA4 base code to already be loaded
   in <head> (see setup instructions), and requires theme.liquid's <body>
   tag to carry these two data attributes:
     <body data-page-type="{{ request.page_type }}" data-page-handle="{% if page %}{{ page.handle }}{% endif %}">
   ========================================================================= */

window.vgTrack = (function () {
  var pageType = document.body.getAttribute('data-page-type') || '';
  var pageHandle = document.body.getAttribute('data-page-handle') || '';

  function fb(event, params, isCustom) {
    if (typeof fbq !== 'function') return;
    fbq(isCustom ? 'trackCustom' : 'track', event, params || {});
  }
  function ga(event, params) {
    if (typeof gtag !== 'function') return;
    gtag('event', event, params || {});
  }
  function clarityEvent(name) {
    if (typeof window.clarity !== 'function') return;
    window.clarity('event', name);
  }

  /* ---------- ViewContent on how-it-works.html (fires once, on load) ---------- */
  if (pageType === 'page' && pageHandle === 'how-it-works') {
    fb('ViewContent', { content_name: 'How It Works' });
    ga('view_content', { content_name: 'How It Works' });
    clarityEvent('ViewContent_HowItWorks');
  }

  /* ---------- Scroll-depth tracking (index.html only) ---------- */
  if (pageType === 'index') {
    var fired = { 25: false, 50: false, 75: false, 100: false };
    function checkScroll() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var pct = Math.round((scrollTop / docHeight) * 100);
      [25, 50, 75, 100].forEach(function (mark) {
        if (!fired[mark] && pct >= mark) {
          fired[mark] = true;
          ga('scroll_depth', { percent: mark });
          fb('ScrollDepth' + mark, { percent: mark }, true);
        }
      });
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { checkScroll(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------- Outbound click tracking: any link to /pages/how-it-works ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="how-it-works"]');
    if (!a) return;
    ga('click_how_it_works', { from_page: pageType });
    fb('ClickHowItWorks', { from_page: pageType }, true);
  });

  /* ---------- Public helpers, called from vg-signup.js and vg-mood-select.liquid ---------- */
  return {
    lead: function (formLocation) {
      fb('Lead', { content_name: formLocation });
      ga('generate_lead', { form_location: formLocation });
      clarityEvent('Lead_' + (formLocation || 'unknown'));
    },
    moodSelected: function (mood, selected) {
      fb('MoodSelected', { mood: mood, selected: selected }, true);
      ga('mood_selected', { mood: mood, selected: selected });
      if (selected) { clarityEvent('MoodSelected_' + mood); }
    },
    phoneOptIn: function () {
      fb('PhoneOptIn', {}, true);
      ga('phone_opt_in', {});
      clarityEvent('PhoneOptIn');
    }
  };
})();
